import { render, staticRenderFns } from "./customImport.vue?vue&type=template&id=2258df70&scoped=true&"
import script from "./customImport.vue?vue&type=script&lang=js&"
export * from "./customImport.vue?vue&type=script&lang=js&"
import style0 from "./customImport.vue?vue&type=style&index=0&id=2258df70&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258df70",
  null
  
)

export default component.exports